import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const stopOperatorSuspension = async (id: string) => {
  return await mutationExecute({
    variables: { id },
    mutation: graphql(`
      mutation StopOperatorSuspension($id: String!) {
        stopOperatorSuspension(id: $id) {
          id
          firstName
          lastName
          email
          phoneNumber
          textNumber
          language1
          language2
          workerSid
          departments
          slackId
          slackWebHook
          slackAlertWebHook
          defaultType
          isDefaultOnly
          closedAt
          slingUserId
          isRehireEligible
          suspendedAt
          isSuspended
          isRecordAllCalls
          isEnableRegFlowView
        }
      }
    `),
  });
};
